import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./customBaseQuery";

export const SkillsUtility = createApi({
  reducerPath: "skillsUtility",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["skillsdata"],
  endpoints: (builder) => ({
    getSkills: builder.query({
      query: (body) => ({
        url: "/utility/skills/fromId",
        method: "POST",
        body: body
      }),
      extraOptions: { service: "Utility" }
    })
  })
});

export const { useGetSkillsQuery, useLazyGetSkillsQuery } = SkillsUtility;
